import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import App from '../App';
import { AuthProvider } from 'oidc-react';
import { oidcSettings } from '../api/OidcSettings';

/**
 * Main component for authentication handling.
 * Skips authentication in developer mode
 * @returns {JSX.Element} the AppRouter component
 */
export const AuthComponent = () => {
  const navigate = useNavigate();

  const [state, setState] = useState({
    configdata: {
      AuthorityUrl: '',
      ClientId: '',
      Redirect: '',
      Redirect_Silent: '',
    },
  });

  useEffect(() => {
    setState({
      ...state,
      configdata: oidcSettings,
    });
  }, []);

  const oidcConfig = {
    onSignIn: async () => {
      navigate({
        pathname: '/',
      });
    },

    authority: state.configdata.AuthorityUrl,
    clientId: state.configdata.ClientId,
    automaticSilentRenew: true,
    grant_type: 'refresh_token',
    response_type: 'code token id_token',
    redirectUri: state.configdata.Redirect,
    silent_redirect_uri: state.configdata.Redirect_Silent,
    scope: 'api://' + state.configdata.ClientId + '/User.Read email openid profile',
    loadUserInfo: false,
    revokeAccessTokenOnSignout: true,
  };
  if (!oidcConfig.authority) {
    return null;
  }

  return (
    <AuthProvider {...oidcConfig}>
      <App />
    </AuthProvider>
  );
};
